import { useRef, useState } from 'react';
import dayjs from 'dayjs';
import { useClickOutside } from '@/hooks/useClickOutside';
import styles from './CalendarDatePicker.module.scss';
import { Calendar } from '../Calendar/Calendar';

interface Props {
  fromDate?: string;
  toDate?: string;
  label: string;
  disabled?: boolean;
  // eslint-disable-next-line no-unused-vars
  onSelectFromDate: (value: string) => void;
  // eslint-disable-next-line no-unused-vars
  onSelectToDate: (value: string) => void;
}

export function CalendarDateRangePicker({ fromDate, toDate, label, disabled, onSelectFromDate, onSelectToDate }: Props) {
  const [open, setOpen] = useState(false);
  //const [thisFromDate, setThisFromDate] = useState<string | undefined>(fromDate);
  //const [thisToDate, setThisToDate] = useState<string | undefined>(toDate);
  const wrapperRef = useRef<HTMLDivElement>(null);
  const triggerRef = useRef<HTMLButtonElement>(null);
  useClickOutside(wrapperRef, open ? 1 : null, () => setOpen(false));

  const toggle = () => {
    setOpen(!open);
  };

  const displayFromDate = !fromDate ? '' : dayjs(fromDate).format('MM/DD/YYYY') + `${toDate ? ' - ' + dayjs(toDate).format('MM/DD/YYYY') : ''}`;

  const handleFromDate = (value: string) => {
    onSelectFromDate(value);
  };

  const handleToDate = (value: string) => {
    if (fromDate && !dayjs(value).isBefore(fromDate)) {
      onSelectToDate(value);
    }
  };

  return (
    <div ref={wrapperRef} className={styles.picker}>
      <button ref={triggerRef} type="button" className={styles.trigger} aria-label={label} aria-haspopup="dialog" aria-expanded={open && !disabled} disabled={disabled} onClick={toggle}>
        <span className={styles.rangeWidth}>{fromDate ? displayFromDate : <div className={styles.fromTo}>From - To</div>}</span>
        <svg className={styles.icon} aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="5" width="18" height="16" rx="2" />
          <path d="M16 3v4M8 3v4M3 11h18" />
        </svg>
      </button>
      {open && !disabled && (
        <div role="dialog" aria-label={`${label} calendar`} className={`${styles.calendar} ${styles.calendarWide}`}>
          <div className={styles.split}>
            <div className={styles.fromPicker}>
              <Calendar value={fromDate} onSelect={handleFromDate} close={() => {}} />
            </div>
            <div>
              <Calendar value={toDate} onSelect={handleToDate} close={() => {}} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
